<template>
  <div class="row" :class="rclass !== '' ? rclass : 'align-items-center'">
    <!-- Left side content -->
    <div class="col-sm-6">
      <div :class="rmclass !== '' ? rmclass : 'banner-container'">
        <!-- Heading -->
        <div :class="hmclass !== '' ? hmclass : 'banner-info'" v-if="heading && heading!==''">
          <h2 :class="heading_class !== '' ? heading_class : 'hf_heading01'" v-html="heading"></h2>
        </div>

        <!-- Body  -->
        <div :class="body_class !== '' ? body_class : 'banner-content'" v-if="body" v-html="body"></div>

        <!-- Actions -->
        <div v-if="show_cta">
          <action :text='cta.text' :link='cta.link' :aclass='cta.aclass' :target='cta.target' :open_as='cta.open_as' :show_btn_icon='cta.show_btn_icon'>
          </action>
        </div>
        <!-- Goal planned count -->
        <div class="user-container" v-if="show_goal_count">
          <ul class="faces-box">
            <li><img src="/img/banner-face01.png" alt=""></li>
            <li><img src="/img/banner-face02.png" alt=""></li>
            <li><img src="/img/banner-face03.png" alt=""></li>
            <li><img src="/img/banner-face04.png" alt=""></li>
          </ul>
          <p class="hf_bodytext01">HappyRich Families</p>
        </div>
        <!-- end goal plan count -->
      </div>
    </div>
    <!-- Right side image -->
    <div class="col-sm-6">
      <div :class="lmclass !== '' ? lmclass : 'banner-image-container'">
        <!-- Regular image -->
        <img v-if="!lazy && image.src != '' && imgExtension !== 'json'" fetchpriority="high" :src="image.src"
        alt="">

        <!-- lazy load image -->
        <img class="lazy" v-if="lazy && image.src != '' && imgExtension !== 'json'" :data-src="image.src"
        alt="">

        <!-- JSON/Lottie image -->
        <lottie-player v-if="image.src != '' && imgExtension == 'json'" :src="image.src" background="transparent"
          speed="1" style="width: 100%; height: 100%;" loop autoplay></lottie-player>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {},
  data() {
    return {
      imgExtension: ''
    }
  },
  props: {
    type: { type: String, default: 'imagetext' }, //imagetext, textimage, texttext, imageimage
    rclass: { type:String, default:'' }, // row class
    cmlass: { type:String, default:'' }, // row class
    lmclass: { type:String, default:'' }, // left main class
    rmclass: { type:String, default:'' }, // right main class
    show_goal_count: { type: Boolean, default: false },
    show_cta: { type: Boolean, default: false },
    // Display properties
    heading: { type:String, default:'' },
    hmclass: { type: String, default: '' },
    heading_class: { type:String, default:'' },
    type: { type:String, default:'imagetext'}, //imagetext, textimage, texttext, imageimage
    image: { type: Object, required:true },
    body: { type: String, default:''},
    body_class: { type: String, default:''},
    cta: { type: Object, default:{} },
    lazy : { type:Boolean, default:false },
  },
  methods: {},
  mounted() {
    if (this.image) {
      if (this.image.hasOwnProperty('src')) {
        var imageObject = this.image.src.split(".");
        this.imgExtension = imageObject[1];
        console.log(this.imgExtension);
      }
    }
  }
};
</script>
